import { render, staticRenderFns } from "./BikyConfigUrl.vue?vue&type=template&id=4951e4d0&scoped=true&"
import script from "./BikyConfigUrl.vue?vue&type=script&lang=ts&"
export * from "./BikyConfigUrl.vue?vue&type=script&lang=ts&"
import style0 from "./BikyConfigUrl.vue?vue&type=style&index=0&id=4951e4d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4951e4d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
